module.exports = __webpack_public_path__ + "static/media/hi-short-1.a5c93524.mp3";